export default __webpack_public_path__ + "static/media/woman.e47084e3.png";